interface ArrowRightIconProps {
	iconColor?: string;
	width?: string;
	height?: string;
}
const ArrowRightIcon = ({ iconColor = '#868E96', width = '8', height = '14' }: ArrowRightIconProps) => (
	<svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.49967 4.1665L12.4845 9.15131C12.9531 9.61994 12.9531 10.3797 12.4845 10.8484L7.49967 15.8332"
			stroke={iconColor}
			strokeWidth="1.5"
			strokeLinecap="round"
		/>
	</svg>
);

export default ArrowRightIcon;
